import React from "react";
import styles from '../../Styles/ServiceType.module.css'
const ServiceType = (props) => {
  const { foldOrHang, setFoldOrHang} = props;
  return (
    <div className={styles.container}>
      <p className={styles.title}>Type *</p>
      <div className={styles.serviceType}>
        <div className={styles.radioBtn}>
          <div
            onClick={() => setFoldOrHang('hang')}
            className={styles.circle}
          >
            <div
              className={`${
                foldOrHang === 'hang' &&
                styles.checked
              }`}
            ></div>
          </div>
          <span>Hang</span>
        </div>
        <div className={styles.radioBtn}>
          <div
            onClick={() => setFoldOrHang('fold')}
            className={styles.circle}
          >
            <span
              className={`${
                foldOrHang === 'fold' && styles.checked
              }`}
            ></span>
          </div>
          <span>Fold</span>
        </div>
      </div>
    </div>
  );
};

export default ServiceType;
